export const SECRET_KEY_CHANGE = 'SECRET_KEY_CHANGE'

/** @reducer **/
export const secretKeyReducer = (state = null, action) => {
    switch (action.type) {
        case SECRET_KEY_CHANGE:
            return action.payload
        default:
            return state
    }
}

export const changeSecretKey = key => dispatch => dispatch(secretKeyChange(key))

/** @action **/
export const secretKeyChange = key => ({
    type: SECRET_KEY_CHANGE,
    payload: key
})



// WEBPACK FOOTER //
// ./modules/secretKey.js